"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CamposVisiveisFabricaNo = void 0;
var bson_1 = require("bson");
var CamposVisiveisFabricaNo = /** @class */ (function () {
    function CamposVisiveisFabricaNo(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.usuario, usuario = _c === void 0 ? '' : _c, _d = _a.camposVisiveis, camposVisiveis = _d === void 0 ? {
            capacidadeOrcada: true,
            capacidadeSap: true,
            saldo: true,
            ocupacao: true,
            percentual: true,
        } : _d;
        this._id = _id;
        this.usuario = usuario;
        this.camposVisiveis = camposVisiveis;
    }
    return CamposVisiveisFabricaNo;
}());
exports.CamposVisiveisFabricaNo = CamposVisiveisFabricaNo;
//# sourceMappingURL=CamposVisiveisFabricaNo.js.map